import React from 'react';

import { CheckboxGroup } from 'src/components/molecules/CheckboxGroup/CheckboxGroup';
import type { FacetOption } from 'src/redux/productsQuery/types/Facet';
import type { FacetOptionsProps } from './types';
import { formatOptionCount } from './utils/formatOptionCount';

const HIDE_ZERO_COUNT_OPTIONS_THRESHOLD = 10;

const onChange = (
  ev: React.ChangeEvent<HTMLInputElement>,
  facet: FacetOptionsProps['facet'],
  onFacetOptionChange: FacetOptionsProps['onFacetOptionChange'],
) => {
  const changedCheckboxValue = ev.target.value;
  const option = facet.options.find((option) => option.value === changedCheckboxValue);

  if (option) {
    onFacetOptionChange({
      key: facet.key,
      title: facet.title,
      options: [
        {
          ...option,
          active: !option.active,
          value: changedCheckboxValue,
        },
      ],
    });
  }
};

export const FacetOptionsMulti = ({ facet, onFacetOptionChange }: FacetOptionsProps) => {
  const getActiveOrNonZeroCountOptions = (options: FacetOption[]) => {
    return options.filter((option) => (option.count ?? 0) > 0 || option.active);
  };
  const facetOptions =
    facet.options.length > HIDE_ZERO_COUNT_OPTIONS_THRESHOLD
      ? getActiveOrNonZeroCountOptions(facet.options)
      : facet.options;

  return (
    <CheckboxGroup
      accessibleLabel={facet.title}
      checkboxData={facetOptions.map(({ active, count, title, value }) => ({
        checked: active,
        disabled: !active && count === 0,
        labelText: title,
        value: value as string,
        secondaryLabelText: formatOptionCount(count),
      }))}
      hideLabel
      name={facet.key}
      onChange={(e) => onChange(e, facet, onFacetOptionChange)}
    />
  );
};
